import {
  ArrowDownTrayIcon,
  Button,
  Flex,
  FlexProps,
  QRCodeViewer,
  Squares2StackIcon,
} from 'components'
import { QRCodeViewerAPI } from 'components/QRCodeViewer'
import { ReactNode, useRef } from 'react'
import { BaseUrl, isProduction } from 'utils'
import { useEvent } from '../../../utils/eventUtils'
import { useQrCodePreferences } from '../../../utils/preferences'

interface Props extends Omit<FlexProps, 'children'> {
  momentId: number
  extraAction?: ReactNode
  size: number
}

export default function PublicQrCode({ momentId, extraAction, size, ...rest }: Props) {
  const [preferences] = useQrCodePreferences()
  const { event } = useEvent()
  const qrCode = useRef<QRCodeViewerAPI>(null)

  if (!event) return null

  const { id, moments, title } = event
  const registrationUrl = `${baseUrl}/${id}?momentId=${momentId}`
  const momentTitle = moments.find(m => m.id === momentId)?.title

  return (
    <Flex alignItems="stretch" direction="column" gap={8} {...rest}>
      <QRCodeViewer
        alignSelf="center"
        ref={qrCode}
        {...preferences}
        data={registrationUrl}
        size={size}
      />

      <Flex gap={2} justifyContent="space-between">
        <Flex gap={2} justifyContent="center" flex={extraAction ? 'none' : 1}>
          <Button
            alignSelf="center"
            leftIcon={<Squares2StackIcon type="outline" />}
            onClick={() => qrCode?.current?.copyToClipboard()}
            variant="outline"
          >
            Copy
          </Button>

          <Button
            alignSelf="center"
            leftIcon={<ArrowDownTrayIcon />}
            onClick={() => qrCode?.current?.download({ name: `${title} - ${momentTitle} QR Code` })}
            variant="outline"
          >
            Download
          </Button>
        </Flex>

        {extraAction}
      </Flex>
    </Flex>
  )
}

const baseUrl = BaseUrl[isProduction() ? 'events' : 'dev-events']
